<script setup>
import Icon from 'dashboard/components-next/icon/Icon.vue';
import { useI18n } from 'vue-i18n';

defineProps({
  icon: { type: String, default: 'i-lucide-link' },
  iconClass: {
    type: String,
    default: 'bg-gradient-to-br from-n-brand to-n-brand',
  },
  title: { type: String, required: true },
  description: { type: String, default: '' },
  showStatus: { type: Boolean, default: true },
});

const { t } = useI18n();
</script>

<template>
  <div
    class="rounded-lg border border-slate-200 bg-slate-50 p-6 dark:border-slate-700 dark:bg-slate-800"
  >
    <div class="flex items-start justify-between gap-4">
      <div class="flex min-w-0 items-start">
        <slot name="avatar">
          <div
            class="mr-4 flex h-12 w-12 shrink-0 items-center justify-center rounded-lg"
            :class="iconClass"
          >
            <Icon :icon="icon" class="h-6 w-6 text-white" />
          </div>
        </slot>
        <div class="min-w-0">
          <h3
            class="mb-1 truncate text-lg font-semibold text-slate-900 dark:text-slate-100"
          >
            {{ title }}
          </h3>
          <p
            v-if="description"
            class="text-sm text-slate-600 dark:text-slate-400"
          >
            {{ description }}
          </p>
          <slot name="meta" />
        </div>
      </div>
      <div class="flex shrink-0 items-center gap-2">
        <span
          v-if="showStatus"
          class="inline-flex items-center rounded-full bg-green-100 px-3 py-1 text-sm font-medium text-green-800 dark:bg-green-900/30 dark:text-green-200"
        >
          <Icon icon="i-ph-check-circle" class="mr-1 h-4 w-4" />
          {{ t('INTEGRATION_APPS.STATUS.ENABLED') }}
        </span>
        <slot name="actions" />
      </div>
    </div>
  </div>
</template>
